module.exports = __webpack_public_path__ + "static/img/item3.63c43e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item3.png
// module id = Dyks
// module chunks = 0